module.exports = __webpack_public_path__ + "static/media/econobit-text-dark.5d8b52da.svg";